export default __webpack_public_path__ + "static/media/banners_raceweek_abu-dhabi_cochemoto_330x330.be25b034.jpg";